import type { Artifact, ArtifactRef } from '@aimo/contracts/web';

/** A supported image representation may itself be the drawing2d artifact; no duplicate preview is required. */
export function artifactPreviewRef(artifact: Artifact): ArtifactRef | undefined {
  if (artifact.kind === 'image' || artifact.kind === 'pdf' || artifact.kind === 'drawing2d' && artifact.mediaType.startsWith('image/')) return { artifactId: artifact.artifactId, version: artifact.version };
  return artifact.previewRefs[0];
}
